import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from './session.service';
import { _common } from './_common';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset.password.component.html'
})
export class ResetPasswordComponent implements OnInit {

  _common = _common;

  email: string = '';
  error: string = null;
  subscription: Subscription;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,

  ) {

  }

  app: string
  link = '/'
  ngOnInit() {

    this.subscription = this.route.queryParams.subscribe((params) => {

      this.app = params.app;
      SessionService.fixTitle(this.app);
      this.link = `/?app=${this.app}`
    })
  }
  title() {
    return document.title;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  proceed() {


    this.http.post('/ext/signup/reset_password', {
      email: this.email,

      app: this.app
    }).subscribe((data: any) => {

      if (!data.succeed) {
        this.error = data.error;
        return;

      }

      let url = '/reset_password_sent'

      this.router.navigate([url], {
        queryParams: {
          app: this.app
        }
      });

    }, (error) => {
      this.router.navigate(['/error']);



    });
  }

}
